module.exports = __webpack_public_path__ + "static/img/Walking.77210ec.png";